module.exports = __webpack_public_path__ + "img/img-classify11.f2716fbf.png";